/**
 * Function to convert an array to an object composed of keys.
 * Keys are selected from the objects through the property name given in key
 *
 * If multiple objects have the same key, only the last one will be added to the resulting object.
 *
 * @example
 * // Returns { '1': {obj1}, '2': {obj2}}
 * keyBy([{ id: 1}, { id: 2}], 'id')
 *
 * @param {Array} array Array of objects to be mapped into the resulting object
 * @param {string} key Property name of objects in array to become key of resulting object
 * @returns Object composed of keys with the array items
 */
function keyBy(array, key) {
	return (array || []).reduce((result, item) => {
		result[item[key]] = item;
		return result;
	}, {});
}

export default keyBy;
